/* eslint-disable react-refresh/only-export-components */
import { Auth0Provider } from "@auth0/auth0-react";
import { PropsWithChildren } from "react";
import { Auth0Bridge, LocalAuthProvider } from "@/lib/auth/useAihrAuth";

export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN as string | undefined,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID as string | undefined,
  audience: import.meta.env.VITE_AUTH0_AUDIENCE as string | undefined,
  enabled:
    Boolean(import.meta.env.VITE_AUTH0_DOMAIN) &&
    Boolean(import.meta.env.VITE_AUTH0_CLIENT_ID) &&
    Boolean(import.meta.env.VITE_AUTH0_AUDIENCE)
};

export function Auth0ProviderWithConfig({ children }: PropsWithChildren) {
  if (!auth0Config.enabled) {
    return <LocalAuthProvider>{children}</LocalAuthProvider>;
  }

  return (
    <Auth0Provider
      domain={auth0Config.domain!}
      clientId={auth0Config.clientId!}
      cacheLocation="localstorage"
      authorizationParams={{
        audience: auth0Config.audience,
        redirect_uri: `${window.location.origin}/callback`,
        scope: "openid profile email offline_access"
      }}
    >
      <Auth0Bridge>{children}</Auth0Bridge>
    </Auth0Provider>
  );
}
